export default __webpack_public_path__ + "static/media/english-to-hungarian-screenshot-05.112c3f09.png";